import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { CreditCard, FileText } from 'lucide-react';

const UserPayments = () => {
  return (
    <div className="space-y-6" data-testid="user-payments">
      <div>
        <h1 className="font-heading text-2xl md:text-[32px] sv-display">Payments</h1>
        <p className="text-muted-foreground">Manage your invoices and payment methods</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="font-heading text-xl flex items-center gap-2">
              <CreditCard className="h-5 w-5" />
              Payment Methods
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-center py-8">
              <CreditCard className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">No payment methods added yet</p>
              <p className="text-sm text-muted-foreground mt-2">
                Payment methods will be requested during booking checkout
              </p>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="font-heading text-xl flex items-center gap-2">
              <FileText className="h-5 w-5" />
              Recent Invoices
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-center py-8">
              <FileText className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">No invoices yet</p>
              <p className="text-sm text-muted-foreground mt-2">
                Invoices will appear here after your first booking
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default UserPayments;
